
import React from "react";


const TransactionTimeline = () =>{
    return(
        <div className="card">
            <div className="card-header">
                <h5>Transaction Timeline</h5>
            </div>
            <div className="card-block">
                <div class="accordion" id="accordionExample2">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsedemoTwo" aria-expanded="false" aria-controls="collapsedemoTwo">
                                Transaction Timeline
                            </button>
                        </h2>
                        <div id="collapsedemoTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample2">
                            <div class="accordion-body">
                                <div className="timeline-container">
                                    <div className="timeline-line">
                                        {/* Item 1 */}
                                        <div className="timeline-item">
                                        <div className="timeline-badge">
                                            <img className="timeline-image" src="./profile.jpg" alt="Profile" />
                                        </div>
                                        <div className="timeline-content">
                                            <h6 className="timeline-item-title">ALL HANDS MEETING</h6>
                                            <p className="timeline-item-description">Lorem ipsum dolor sit amet, today at 12:00 PM</p>
                                            <p className="timeline-item-time text-muted">12:00 PM</p>
                                        </div>
                                        </div>

                                        {/* Item 2 */}
                                        <div className="timeline-item">
                                        <div className="timeline-badge">
                                            <img className="timeline-image" src="./profile.jpg" alt="Profile" />
                                        </div>
                                        <div className="timeline-content">
                                            <h6 className="timeline-item-title">Project Meeting</h6>
                                            <p className="timeline-item-description">At 1:00 PM</p>
                                            <p className="timeline-item-time text-muted">1:00 PM</p>
                                        </div>
                                        </div>

                                        {/* Item 3 */}
                                        <div className="timeline-item">
                                        <div className="timeline-badge">
                                            <img className="timeline-image" src="./profile.jpg" alt="Profile" />
                                        </div>
                                        <div className="timeline-content">
                                            <h6 className="timeline-item-title">Critical Issue</h6>
                                            <p className="timeline-item-description">Needs immediate attention.</p>
                                            <p className="timeline-item-time text-muted">2:30 PM</p>
                                        </div>
                                        </div>

                                        {/* Item 4 */}
                                        <div className="timeline-item">
                                        <div className="timeline-badge">
                                            <img className="timeline-image" src="./profile.jpg" alt="Profile" />
                                        </div>
                                        <div className="timeline-content">
                                            <h6 className="timeline-item-title">Brainstorming Session</h6>
                                            <p className="timeline-item-description">Discuss new ideas and solutions.</p>
                                            <p className="timeline-item-time text-muted">4:00 PM</p>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default TransactionTimeline;